/**
 * ReviewEditRatingsStep
 *
 * Step 1 of the review edit wizard: overall and category ratings.
 * Used inside CustomerReviewEdit's progress Card.
 */
import StarRating from './StarRating';
import Button from '../common/Button';

export default function ReviewEditRatingsStep({ reviewData, onChangeRating, canProceed, onNext }) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Rate Your Experience</h3>
        <p className="text-sm text-gray-600 mb-6">
          Please rate your overall experience and specific aspects of the trip
        </p>
      </div>

      <StarRating
        value={reviewData.overall_rating}
        onChange={(rating) => onChangeRating('overall_rating', rating)}
        label="Overall Rating *"
      />

      <div className="border-t border-gray-200 pt-6">
        <h4 className="text-md font-semibold text-gray-900 mb-4">Category Ratings *</h4>
        <div className="space-y-4">
          <StarRating
            value={reviewData.communication_rating}
            onChange={(rating) => onChangeRating('communication_rating', rating)}
            label="Communication"
          />
          <StarRating
            value={reviewData.knowledge_rating}
            onChange={(rating) => onChangeRating('knowledge_rating', rating)}
            label="Knowledge & Expertise"
          />
          <StarRating
            value={reviewData.professionalism_rating}
            onChange={(rating) => onChangeRating('professionalism_rating', rating)}
            label="Professionalism"
          />
          <StarRating
            value={reviewData.value_rating}
            onChange={(rating) => onChangeRating('value_rating', rating)}
            label="Value for Money"
          />
        </div>
      </div>

      <div className="flex justify-end pt-4">
        <Button onClick={onNext} disabled={!canProceed}>
          Continue to Written Review
        </Button>
      </div>
    </div>
  );
}
